import qs from 'qs'
import { getBookingDetails } from 'dataSource/booking'
import { pageRoutes } from 'constants/routing'
import { initialBookingHelperState } from 'state/booking/constants'
import { VerifyLoginTokenParams, VerifyTokenProps } from './types'
import { TWPERMISSIONS } from 'dataSource/auth/types'
import { UserTypes } from 'constants/common'
import { preSelectAppointmentModeId } from 'components/app/NewBookings/utils/preselectionUtil'
import { groupFilters } from 'app/ProviderSearch/utils'
import { COOKIE_KEYS } from 'constants/common'
import Cookies from 'js-cookie'

export const verifyLoginToken = async (
  params: VerifyLoginTokenParams
): Promise<VerifyTokenProps> => {
  const { redirectTo, authResponse } = params
  const props: VerifyTokenProps = {
    error: false,
  }

  try {
    props.access_token = authResponse.access_token
    props.expires_in = authResponse.expires_in

    if (redirectTo?.includes(pageRoutes.BOOKING)) {
      const { slotId } = qs.parse(redirectTo)
      const { slot, provider } = await getBookingDetails(slotId as string)

      // Read counselingTypeId from cookie that was set when user clicked time slot
      const preSelectionCookie = Cookies.get(COOKIE_KEYS.PRE_BOOKING_SELECTION)
      let counselingTypeId: string | undefined

      if (preSelectionCookie) {
        try {
          const cookieData = JSON.parse(preSelectionCookie)
          counselingTypeId = cookieData.counselingTypeId
        } catch (error) {
          // Silently handle cookie parsing errors
        }
      }

      // Preselect appointment mode using provider's existing filter data
      const groupedFilters = groupFilters(provider.filters || [])
      const appointmentModeId = preSelectAppointmentModeId(slot, groupedFilters)

      const bookingHelperState: BookingHelperState = {
        ...initialBookingHelperState,
        selectedSlot: {
          slot: { ...slot, practiceId: slot.schedule.practiceId },
          provider: provider,
        },
        providerDetails: provider,
        filters: {
          slotAvailabilityTypes: slot.schedule.availabilityType,
        },
        isBookingComplete: false,
      }
      props.bookingHelperDetails = bookingHelperState
      props.appointmentModeId = appointmentModeId
      props.counselingTypeId = counselingTypeId ?? null
    }

    if (redirectTo) {
      props.redirectTo = redirectTo
    }

    return props
  } catch (error) {
    props.error = true
    props.errorMsg = error.message || 'Error while fetching booking details'
  }

  return props
}

export const checkUserType = (permissions: TWPERMISSIONS[]): string => {
  if (permissions.includes(TWPERMISSIONS.CLINICIAN)) {
    return UserTypes.CLINICIAN
  } else if (permissions.includes(TWPERMISSIONS.SUPPORT)) {
    return UserTypes.SUPPORT
  }

  return UserTypes.PATIENT
}

export const isThriveworksSupportEmail = (email: string): boolean =>
  email.toLowerCase().endsWith('@thriveworks.com')

/**
 * Safely validates and normalizes a redirect path to prevent
 * open redirect vulnerabilities.
 */
export const getSafeReturnTo = (returnTo?: string): string | undefined => {
  if (!returnTo) {
    return
  }

  try {
    const url = new URL(returnTo, window.location.origin)

    if (url.origin !== window.location.origin) {
      return
    }

    return url.pathname + url.search + url.hash
  } catch {
    return
  }
}
